<template>
  <SideNav />

  <header>
    <div class="page-header min-vh-60 bg-gradient-dark">
      <video
        class="position-absolute fixed-top  h-100 z-index-0  rounded-5 px-0"
        id="video"
        playsinline="playsinline"
        autoplay="autoplay"
        muted="muted"
        loop="loop"
        poster="assets/img/cloudbg3.jpg"
        style="object-fit: cover;"
      >
        <source
          type="video/mp4"
          src="assets/img/cloud.mp4"
        >
      </video>
      <span class="mask bg-gradient-dark opacity-3" />
      <div class="container">
        <div class="row fadeIn1 fadeInBottom ">
          <div class="col-lg-8 mx-auto text-white text-center">
            <h2 class="text-white">
              Cloud Raise Technology
            </h2>
            研發能力是昀揚科技取得成功的關鍵，我們深信創新是推動行業發展和提供卓越產品的關鍵要素。
            憑藉著穩固的研發基礎和卓越的研發團隊，我們能夠不段追求突破，開發出具有競爭力的產品。
            我們將持續在研發領域投資，挑戰自我、克服種種困難，推動行業發展，致力成為客戶最信賴的合作伙伴
          </div>
        </div>
      </div>
    </div>
  </header>


  <div class="card card-body blur shadow-blur mx-2 mx-md-4 mt-n6 mb-7">
    <div class="container px-0">
      <div class="col-lg-12 mt-2 mt-md-5">
        <div class="fadeIn2 fadeInBottom ">
          <div class="col-lg-6 ms-auto me-auto text-center">
            <div class="p-3 info-hover-warning mb-4">
              <div class="icon icon-shape bg-gradient-warning shadow icon-shape-circle text-primary">
                <i class="fa fa-network-wired opacity-10" />
              </div>
            </div>            
            <h4 class="card-title mb-4">
              <a
                href="javascript:;"
                @click="goToPage('TronEdu')"
                class="text-dark"
              >產品系列</a>
            </h4>
            <p class="card-description  mb-4">
              昀揚科技，致力於智慧城市、智慧園區、智慧工廠、AI人工智能、數位雙生、元宇宙智能教育、教育科技等服務。
              團隊累積多年軟體開發經驗，專注人工智能、繪圖動畫引擎、容器化微服務、雲端應用等技術。
              提供客戶三高一低（高品質、高效率、高擴展性、低成本）之資訊化應用產品及提升客戶市場競爭力。
            </p>
          </div>
        </div>


        <div class="row mt-5">
          <section class="pt-7 pb-0">
            <div class="container">
              <div class="row">
                <div class="col-md-6 mb-6">
                  <div class="card mt-5 mt-md-0  h-100 move-on-hover">
                    <div class="card-header p-0 mx-3 mt-n4 position-relative z-index-2 mb-3">
                      <a
                        class="d-block blur-shadow-image"
                        href="javascript:;"
                        @click="goToPage('TronEdu')"
                      >
                        <img
                          src="assets/img/tronedu-s.jpg"
                          alt="img-blur-shadow"
                          class="img-fluid border-radius-lg"
                          loading="lazy"
                        >
                      </a>
                      <div
                        class="colored-shadow"
                        style="background-image: url(&quot;assets/img/tronedu-s.jpg&quot;);"
                      />
                    </div>
                    <div class="card-body pt-3">
                      <a 
                        href="javascript:;"
                        @click="goToPage('TronEdu')"
                      >
                        <h3>
                          TronEdu 創益學
                        </h3>
                        <p class="text-primary mb-2">輕鬆導入 • 價格實惠 • 減低人力成本</p>
               
                        <p class="text-dark">
                          創益學 TronEdu 主平台課程平台系統（Curriculum Platform）為支援小學、國中、高中五個學習階段、108課綱、全領域、全科、全版及知識架構的課程管理平台，系統可透過昀揚科技的雲端資料中心更新教育部公佈每年最新版的知識架構與課綱，亦可應用在專業證照、教育訓練、高普考、幼兒等需求且可客製化知識架構及課綱。使用者可選購各種平台系統方案，部署在線上考試、出卷、線上影音函授課程、電子書、學力診斷、學習診斷、智能補救、智能助理、遠距教學等雲端應用。
                        </p> 
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-6">
                  <div class="card mt-5 mt-md-0  h-100 move-on-hover">
                    <div class="card-header p-0 mx-3 mt-n4 position-relative z-index-2 mb-3">
                      <a
                        class="d-block blur-shadow-image"
                        href="javascript:;"
                        @click="goToPage('TronMap')"
                      >
                        <img
                          src="assets/img/bmms6.jpg"
                          alt="img-blur-shadow"
                          class="img-fluid border-radius-lg"
                          loading="lazy"
                        >
                      </a>
                      <div
                        class="colored-shadow"
                        style="background-image: url(&quot;assets/img/bmms6.jpg&quot;);"
                      />
                    </div>
                    <div class="card-body pt-3 h-100">
                      <a 
                        href="javascript:;"
                        @click="goToPage('TronMap')"
                      >
                        <h3>
                          TronMap Intelligence Drawing <br>
                          創益圖智慧繪圖系列產品
                        </h3>
                        <p class="mb-2 text-success">
                          智慧園區繪圖系統/元宇宙系統（ParkDraw / ParkMeta）、
                          智慧建築繪圖系統/元宇宙系統（BuildDraw / BuildMeta）
                        </p>
                        <p class="text-dark">
                          提供高品質動畫繪圖渲染技術在所見即所得沉浸式元宇宙體驗工作模式下無需數年僅需幾天即可完成高品質的工程，只要會打電動不需要會寫程式即可投入建置、維運、管理等工作，大幅度降低導入失敗的風險及門檻。
                        </p>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-6">
                  <div class="card mt-5 mt-lg-0 h-100 move-on-hover">
                    <div class="card-header p-0 mx-3 mt-n4 position-relative z-index-2 mb-3">
                      <a
                        class="d-block blur-shadow-image"
                        href="javascript:;"
                        @click="goToPage('TronSecurity')"
                      >
                        <img
                          src="assets/img/security2-s.jpg"
                          alt="img-blur-shadow"
                          class="img-fluid border-radius-lg"
                          loading="lazy"
                        >
                      </a>
                      <div
                        class="colored-shadow"
                        style="background-image: url(&quot;assets/img/security2-s.jpg&quot;);"
                      />
                    </div>
                    <div class="card-body pt-3 h-100">
                      <a 
                        href="javascript:;"
                        @click="goToPage('TronSecurity')"
                      >
                        <h3>
                          TronSecurity 資訊安全
                        </h3>
                        <p class="text-warning mb-2">FIDO2 Key • AuthFi authenticator app • PassKey</p>
               
                        <p class="text-dark">
                          TronSecurity Platform 與工研院資安整合服務平台（Security Platform as a Services , SECPAAS）及AuthenTrend（歐生全）等合作伙伴進行技術轉移合作，提供您建立零信任架構（ZTA）中決策引擎「身分鑑別」的核心機制，使用者可以使用 FIDO2 Key（ATKey.Pro、ATKey.Card、AT.Wallet）、AuthFi authenticator app（download from store）、PassKey（Android 11+、iOS 15+、iCloud Keychain enabled）在您的網站服務平台下進行無密碼或多因子認證（MFA），建立一個安全不會被釣魚且易於管理的環境。
                        </p> 
                      </a>
                    </div>
                  </div>
                </div>          
                <div class="col-md-6 mb-6">
                  <div class="card mt-5 mt-lg-0 h-100 move-on-hover">
                    <div class="card-header p-0 mx-3 mt-n4 position-relative z-index-2 mb-3">
                      <a
                        class="d-block blur-shadow-image"
                        href="javascript:;"
                        @click="goToPage('CRStream')"
                      >
                        <img
                          src="assets/img/cratream5.jpg"
                          alt="img-blur-shadow"
                          class="img-fluid border-radius-lg"
                          loading="lazy"
                        >
                      </a>
                      <div
                        class="colored-shadow"
                        style="background-image: url(&quot;assets/img/cratream5.jpg&quot;);"
                      />
                    </div>
                    <div class="card-body pt-3">
                      <a 
                        href="javascript:;"
                        @click="goToPage('CRStream')"
                      >
                        <h3>
                          CRStream 影音串流
                        </h3>  
                        <p class="text-info mb-2">帳號權限模組 • 傳輸/設定模組 • 編輯工具程式</p>
                
                        <p class="text-dark">
                          CRStream Standard是一套針對影音串流媒體服務開發與整合所設計的最佳解決方案，其中包含CRStream Converter和CRStream Platform以及提供全載具（手機、平板、電腦、智能電視）播放SDK，使用者可以運用本系統快速建置及擴展高效穩定的影音串流媒體服務。SMDN獨家專利技術提供更多元及品質優化的演算法。比起CDN、公有雲，SMDN專利技術提供更加便宜及大幅度降低營運成本的解決方案。<br>&nbsp;
                        </p>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
  <Footer />
</template>
<script>
/* eslint-disable import/no-absolute-path */
// eslint-disable-next-line import/no-unresolved
import { config } from '@/include/config';
import {
  h,
  ref,
  toRefs,
  reactive,
  watch,
  inject,
  onMounted,
  onBeforeUpdate,
  onUpdated
} from 'vue';
import { oltConsole, oAA , oAuth, oApiError , oFrame } from '@/lib/oltModule/initOltVue3';
//import Header from '@/components/Header.vue';
import { SideNav , Header , Footer } from '@/components/Frame';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';

export default {
  name: 'App',
  components: {
    SideNav,
    //Header,
    //NavBar,
    // Settings,
    Footer,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    onMounted(async () => {
      chkLogin();
    });
    // Reload MDInput End

    onUpdated(async () => {
      // 修改 VUE 時 必需全部強制關閉 Modals 
      // eslint-disable-next-line no-undef
      //await oAdminFrame.closeAllModals() ;
    }) ;

    function goToPage(page){
      if(router.currentRoute.value.name == page) { return; }
      router.push(page);
    }

    function chkLogin(){
      let isLogin = oAuth.isLogin(store);

      if(!isLogin){
        //router.push({ path: '/AuthPage/SignIn' });
      }
    }

    return {
      hiddenHeader:false,
      // api setting
      setDebugMode: true,
      apiDebug: false,
      apiName: '',
      perPage: 3, //筆數
      pageMode: true,
      perPageOptions: [5, 10, 25, 50, 75, 100],
      // data
      userInfo:{coin:0 , point:0},
      token:null,
      // function
      goToPage,
      chkLogin,
    };
  },
  created() {
  },
  mounted() {
    oFrame.initMD();
  },
  methods: {
  }
};
</script>
